export default {
  postIdentifyCode(options) {
    return this.http('Passport', 'post', '/api/v1/register/send_cellphone_verification.json', options);
  },

  checkIdentifyCode(options) {
    return this.http('Passport', 'post', '/api/v1/register/verify_cellphone', options);
  },

  getUserRegisterMes(options) {
    return this.http('Passport', 'post', '/api/v1/register/by_cellphone', options);
  },

  getSaIdentity() {
    return this.http('api', 'get', '/open-interface/v1/data/report_distinct');
  }
};
